import { SVGProps } from 'react';
const SvgReturn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M12.452 0.499023V8.50302H1.67597L5.13197 12.007C5.17997 12.063 5.20797 12.123 5.21597 12.187C5.22397 12.259 5.20797 12.323 5.16797 12.379L5.13197 12.415C5.08397 12.463 5.02397 12.491 4.95197 12.499C4.88797 12.507 4.82797 12.491 4.77197 12.451L0.547974 8.16702L4.73597 3.91902C4.79197 3.85502 4.85597 3.82302 4.92797 3.82302C5.00797 3.82302 5.07197 3.85102 5.11997 3.90702C5.17597 3.96302 5.20397 4.02702 5.20397 4.09902C5.21197 4.16302 5.19597 4.22302 5.15597 4.27902L5.13197 4.31502L1.55597 7.95102H11.912V1.05102H6.49997C6.41997 1.05102 6.35197 1.02702 6.29597 0.979023C6.24797 0.923023 6.22397 0.855023 6.22397 0.775023C6.22397 0.695024 6.24797 0.631023 6.29597 0.583023C6.35197 0.527023 6.41997 0.499023 6.49997 0.499023H12.452Z"
      fill="#D04A02"
    />
  </svg>
);
export default SvgReturn;
